import React , {useEffect, useState} from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import FiberManualRecord from "@material-ui/icons/FiberManualRecord";


// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import ImageUpload from "components/CustomUpload/ImageUpload.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";

import { Link, Redirect, useParams } from "react-router-dom";

import readXlsxFile from 'read-excel-file'

import axios from 'axios'

import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";

const useStyles = makeStyles(styles);

export default function NewUser() {

    const {id} = useParams();

    const [description, setdescription] = React.useState("");
    const [descriptionState, setdescriptionState] = React.useState("");
    const [material_cost, setmaterial_cost] = React.useState("");
    const [labor_cost, setlabor_cost] = React.useState("");
    const [redirctTo, setRedirctTo] = useState(false);
    const [redirctTo_new_user, setRedirctTo_new_user] = useState(false);
    const [token_logged, settoken_logged] = React.useState("");
    const [tc, setTC] = React.useState(false);
    const [Errmessage, setErrmessage] = React.useState("");

    const [sheets_, setsheets_] = React.useState("");

    const [sections, setsections] = React.useState([]);

    

    

    const verifyLength = (value, length) => {
        if (value.length >= length) {
            return true;
        }
        return false;
    };

    

  
  React.useEffect(() => {
      const local_login = localStorage.getItem('local_login')
      let token = "";
      if(local_login){
        try {
        const getToken = async () => {
          const res = await axios.post('/user/refresh_token', null)
          
          token = res.data.access_token;

          settoken_logged(token);

          const res2 = await axios.get('/user/infor', {
            headers: {Authorization: token}
          })     
          console.log( res2.data );

        }
        getToken()
          } catch (err) {
            setRedirctTo(true);
        }
      }else{
        setRedirctTo(true)
      }
    
  }, [  ]);
  

  const registerClick = async e => {
    
    let input = document.getElementById('input')

    readXlsxFile(input.files[0], { getSheets: true }).then((sheets) => {
      // sheets === [{ name: 'Sheet1' }, { name: 'Sheet2' }]
      setsheets_(sheets)
      console.log(sheets);
    })

    let sections_new = sections;


    console.log(sheets_);

    for (let index = 0; index < sheets_.length; index++) {
      console.log(index );
    readXlsxFile(input.files[0], { sheet: index + 1 }).then((rows) => {
        // `rows` is an array of rows
        // each row being an array of cells.
        console.log(rows);

        let section_array = [];        
        let current_section = 0;
        let current_code_reference = -1;
        let principal_section = "";

        for (let i = 1; i < rows.length; i++) {
             if(i == 1){
                principal_section = console.log(rows[i][1])
                let section = {};
                section_array.push(section);
                section_array[current_section].section_name = rows[i][1];
                section_array[current_section].code_references = [];
                section_array[current_section].informations = [];
             }
             if(rows[i][0] == '#'){
                console.log("sub section title",rows[i][1])
                let section = {};
                section_array.push(section);
                current_code_reference = -1;
                current_section++;
                section_array[current_section].section_name = rows[i][1];
                section_array[current_section].code_references = [];
                section_array[current_section].informations = [];
             }
             if(rows[i][0] != null && rows[i][0] != '#'){
                let reference_item = {};   
                reference_item.reference = rows[i][0].toString();
                reference_item.description = rows[i][1];
                reference_item.comments = [];   
                reference_item.recommendations = [];   
                reference_item.method = "1";
                if(rows[i][5] != ""){
                  reference_item.figures = rows[i][5];
                }else{
                  reference_item.figures = "";
                }
                
                if(rows[i][2] != null){
                    reference_item.comments.push(rows[i][2]);
                }
                if(rows[i][3] != null){
                    reference_item.recommendations.push(rows[i][3]);
                }

                section_array[current_section].code_references.push(reference_item)   
                current_code_reference++;             
             }
             if(rows[i][0] == null ){
                if(rows[i][2] != null){
                    section_array[current_section].code_references[current_code_reference].comments.push(rows[i][2]);
                }
                if(rows[i][3] != null){
                    section_array[current_section].code_references[current_code_reference].recommendations.push(rows[i][3]);
                }
                if(rows[i][3] == "**"){
                    section_array[current_section].informations.push(rows[i][1]);
                }
             }

        }
        console.log("623b36c9f105150016d88377")
        console.log("-- ---- - -")
        console.log(section_array);
        
        sections_new.push(section_array);
        
          
    })
    }
    setsections(sections_new);
    


  };

  const save_ = async () => {
    let sections_new = sections;

    for (let index = 0; index < sections_new.length; index++) {

      let principal_section = sections_new[index][0].section_name;

      const res = await axios.post('/codeset/register_sections', {
          sections : sections_new[index], codeset_id : "623b36c9f105150016d88377", principal_section: principal_section
      })  

    }
  };



  const classes = useStyles();

  if (redirctTo){
    return <Redirect to='/auth/login-page'  />
  }

  if (redirctTo_new_user){
    return <Redirect to={'/admin/signs/'+ id}  />
  }


  const showNotification = place => {
    setTC(true);
    setTimeout(function() {
      setTC(false);
    }, 3000);
  };
  
  
  return (
    <div>

      <Snackbar
        place="tc"
        color="rose"
        icon={AddAlert}
        message={Errmessage}
        open={tc}
        closeNotification={() => setTC(false)}
        close
      />
      
      <GridContainer>
          
        <GridItem xs={12} sm={12} md={12}>
            <div className={classes.right}>
                <Button onClick={registerClick} color="rose" className={classes.right}>
                    Import
                </Button>
                <Button onClick={save_} color="rose" className={classes.right}>
                    save
                </Button>
            </div>
          <Card>
            <CardBody>
              <input type="file" id="input" />
            
            </CardBody>
          </Card>
          <div className={classes.right}>
                <Button onClick={registerClick} color="rose" className={classes.right}>
                Import
                </Button>
            </div>
        </GridItem>
      </GridContainer>
    </div>
  );
}
